export const state = {
    currentUser: null,
    userFSDocument: null,
    emailOrPhoneNumber: '',

};